module.exports = __webpack_public_path__ + "img/logo-sby.5ffeb19e.png";